import u from 'umbrellajs/umbrella.esm.js';

export function initDropdowns() {
  // Toggle dropdown
  u('[data-dropdown-toggle]').on('click', function (e) {
    e.stopPropagation();

    const wrapper = this.closest('[data-dropdown-wrapper]');
    const $wrapper = u(wrapper);
    const $dropdown = $wrapper.find('[data-dropdown-menu]');
    const $arrow = u(this).find('.arrow');

    const wasOpen = !$dropdown.hasClass('hidden');

    u('[data-dropdown-wrapper]').each(w => {
      u(w).find('[data-dropdown-menu]').addClass('hidden');
      u(w).find('.arrow').removeClass('rotate-180');
    });

    if (!wasOpen) {
      $dropdown.removeClass('hidden');
      $arrow.addClass('rotate-180');
    }
  });

  // Resize
  window.addEventListener('resize', () => {
    u('[data-dropdown-wrapper]').each(wrapper => {
      u(wrapper).find('[data-dropdown-menu]').addClass('hidden');
      u(wrapper).find('.arrow').removeClass('rotate-180');
    });
  });

  // Click outside
  document.addEventListener('click', e => {
    u('[data-dropdown-wrapper]').each(wrapper => {
      if (!wrapper.contains(e.target)) {
        u(wrapper).find('[data-dropdown-menu]').addClass('hidden');
        u(wrapper).find('.arrow').removeClass('rotate-180');
      }
    });
  });
}
``